import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "backdrop", "trigger", "openIcon", "closeIcon", "header"]

  connect() {
    this.boundCloseOnEscape = this.closeOnEscape.bind(this)
    this.boundHandleTouchStart = this.handleTouchStart.bind(this)
    this.boundHandleTouchMove = this.handleTouchMove.bind(this)
    this.boundHandleTouchEnd = this.handleTouchEnd.bind(this)

    if (this.hasHeaderTarget) {
      this.headerTarget.addEventListener("touchstart", this.boundHandleTouchStart, { passive: true })
      this.headerTarget.addEventListener("touchmove", this.boundHandleTouchMove, { passive: false })
      this.headerTarget.addEventListener("touchend", this.boundHandleTouchEnd, { passive: true })
      this.headerTarget.addEventListener("touchcancel", this.boundHandleTouchEnd, { passive: true })
    }
  }

  disconnect() {
    try {
      this.close()
    } catch (e) {
      // Таргет мог быть уже удалён из DOM — игнорируем.
    }

    if (this.hasHeaderTarget) {
      this.headerTarget.removeEventListener("touchstart", this.boundHandleTouchStart)
      this.headerTarget.removeEventListener("touchmove", this.boundHandleTouchMove)
      this.headerTarget.removeEventListener("touchend", this.boundHandleTouchEnd)
      this.headerTarget.removeEventListener("touchcancel", this.boundHandleTouchEnd)
    }
  }

  toggle(event) {
    event.preventDefault()

    const willExpand = this.contentTarget.classList.contains("hidden")

    if (willExpand) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    if (this.hasContentTarget) {
      this.contentTarget.classList.remove("hidden")
    }
    this.resetDrag()

    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.remove("hidden")
    }

    if (this.hasTriggerTarget) {
      this.triggerTarget.setAttribute("aria-expanded", "true")
    }

    if (this.hasOpenIconTarget && this.hasCloseIconTarget) {
      this.openIconTarget.classList.add("hidden")
      this.closeIconTarget.classList.remove("hidden")
    }

    if (this.isMobile()) {
      document.body.style.overflow = "hidden"
      document.addEventListener("keydown", this.boundCloseOnEscape)
    }
  }

  close() {
    if (this.hasContentTarget) {
      this.contentTarget.classList.add("hidden")
    }
    this.resetDrag()

    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.add("hidden")
    }

    if (this.hasTriggerTarget) {
      this.triggerTarget.setAttribute("aria-expanded", "false")
    }

    if (this.hasOpenIconTarget && this.hasCloseIconTarget) {
      this.openIconTarget.classList.remove("hidden")
      this.closeIconTarget.classList.add("hidden")
    }

    document.body.style.overflow = ""
    document.removeEventListener("keydown", this.boundCloseOnEscape)
  }

  resetDrag() {
    this.isDragging = false
    this.startY = 0
    this.currentTranslate = 0
    if (this.hasContentTarget) {
      this.contentTarget.style.transition = ""
      this.contentTarget.style.transform = ""
    }
  }

  handleTouchStart(event) {
    if (!this.isMobile() || !this.isOpen()) return

    this.isDragging = true
    this.startY = event.touches[0].clientY
    this.currentTranslate = 0
    this.contentTarget.style.transition = "none"
  }

  handleTouchMove(event) {
    if (!this.isDragging) return

    const deltaY = event.touches[0].clientY - this.startY
    if (deltaY < 0) return

    this.currentTranslate = deltaY
    this.contentTarget.style.transform = `translateY(${deltaY}px)`
    event.preventDefault()
  }

  handleTouchEnd() {
    if (!this.isDragging) return

    this.isDragging = false
    const threshold = Math.min(80, this.contentTarget.offsetHeight * 0.25)

    if (this.currentTranslate > threshold) {
      this.close()
    } else {
      this.contentTarget.style.transition = "transform 200ms ease-out"
      this.contentTarget.style.transform = "translateY(0)"
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  isOpen() {
    return this.hasContentTarget && !this.contentTarget.classList.contains("hidden")
  }

  isMobile() {
    return window.innerWidth < 800
  }
}
